/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { DataGrid } from '@mui/x-data-grid';
import { Button, IconButton, Stack } from '@mui/material';

import PropTypes from 'prop-types';

import api from '../../../services/api';
import PointFormModal from '../PointFormModal';

import './styles.css';

export default function BeaconsCard({
  scrollToMapComponent,
  points,
  setPoints,
  setAudioFile,
  setImageFile,
  setFormData,
  setFormEditData,
  selectedCoords,
  setSelectedCoords,
  setSelectedPoint,
  categories,
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [pointToEdit, setPointToEdit] = useState(null);

  const openCreate = () => {
    setPointToEdit(null);
    setModalOpen(true);
  };

  const openEdit = (point) => {
    setPointToEdit(point);
    setModalOpen(true);
  };

  const handleSaved = (updatedPoint) => {
    setPoints(points.map((p) => (p.id === updatedPoint.id ? { ...p, ...updatedPoint } : p)));
  };
  const [beacons, setBeacons] = useState([]); // Estado para armazenar a lista de beacons

  useEffect(() => {
    // Função para buscar todos os beacons do banco de dados
    const fetchBeacons = async () => {
      try {
        const response = await api.get('/beacons');
        setBeacons(response.data); // Atualiza o estado com a lista de beacons
      } catch (err) {
        console.error(err);
      }
    };

    fetchBeacons();
  }, []); // Executa a busca dos beacons apenas uma vez, na montagem do componente

  const onlyBeacons = points.filter((point) => point.type === 'beacon');

  // Função para obter o nome do beacon a partir do seu ID
  const getBeaconNameById = (beaconId) => {
    const beacon = beacons.find((b) => b.id === beaconId);
    return beacon ? beacon.name : '';
  };

  const handleDeletePoint = async (pointObj) => {
    try {
      const deleteAudioFilePromise = pointObj.audioUrl ? api.delete(`/points/file/audio/${pointObj.id}`) : null;
      const deleteImageFilePromise = pointObj.imageUrl ? api.delete(`/points/file/image/${pointObj.id}`) : null;
      const deletePointPromise = api.delete(`/points/${pointObj.id}`);

      // ask for confirmation before delete
      const confirmation = window.confirm('Tem certeza que deseja excluir este ponto?');

      if (!confirmation) return;

      await Promise.allSettled([
        deleteAudioFilePromise,
        deleteImageFilePromise,
        deletePointPromise,
      ]);

      setPoints(points.filter((point) => point.id !== pointObj.id));
      setAudioFile(null);
      setImageFile(null);
      setFormData({
        type: 'gps',
        name: '',
        category: '',
        description: '',
        radius: 10,
        beacon: '',
        isVisible: true,
        isAutomaticallyPlayed: true,
        audioUrl: '',
        imageUrl: '',
      });
      setFormEditData({
        id: '',
        name: '',
        categoryId: '',
        category: '',
        description: '',
        type: 'gps',
        radius: 10,
        beacon: '',
        isVisible: true,
        isAutomaticallyPlayed: true,
        audioURL: '',
        imageURL: '',
      });
      setSelectedCoords({
        lat: null,
        lng: null,
      });
      setSelectedPoint(null);
      alert('Ponto excluído com sucesso!');
    } catch (err) {
      console.error(err);
    }
  };

  const renderCellActions = (params) => (
    <Stack direction="row" spacing={1}>
      <IconButton
        size="small"
        aria-label="Editar"
        onClick={(e) => {
          e.stopPropagation();
          openEdit(params.row);
        }}
      >
        <EditIcon fontSize="small" />
      </IconButton>
      <IconButton
        size="small"
        aria-label="Excluir"
        onClick={(e) => {
          e.stopPropagation();
          handleDeletePoint(params.row);
        }}
      >
        <DeleteIcon fontSize="small" />
      </IconButton>
    </Stack>
  );

  // Beacon não tem coord relevante no mapa — clique no nome abre edição via modal.
  const renderName = (params) => {
    const handleNameClick = () => openEdit(params.row);

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        handleNameClick();
      }
    };

    return (
      <span
        onClick={handleNameClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={0}
        style={{
          cursor: 'pointer',
          color: '#414141',
        }}
      >
        {params.row.name}
      </span>
    );
  };

  const columns = [
    {
      field: 'action',
      headerName: '#',
      sortable: false,
      headerAlign: 'center',
      disableColumnMenu: true,
      renderCell: renderCellActions,
      minWidth: 110,
      flex: 1,
    },
    {
      field: 'name',
      headerName: 'Nome',
      headerAlign: 'center',
      renderCell: renderName,
      minWidth: 140,
      flex: 2,
    },
    {
      field: 'category',
      headerName: 'Categoria',
      headerAlign: 'center',
      minWidth: 120,
      flex: 3,
    },
    {
      field: 'beaconId',
      headerName: 'Beacon',
      headerAlign: 'center',
      valueGetter: (params) => getBeaconNameById(params.value),
      minWidth: 140,
      flex: 3,
    },
  ];

  const dataGridStyles = {
    mt: 2,
    border: 'none',
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-row': {
      borderBottom: 'none',
    },
    '& .MuiDataGrid-rowSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-cell': {
      // borderBottom: 'none',

      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
  };

  return (
    <div className="points-card">
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 8,
      }}
      >
        <span className="points-title">
          <h1>Beacons</h1>
        </span>
        <Button
          variant="contained"
          color="success"
          size="small"
          startIcon={<AddIcon />}
          onClick={openCreate}
        >
          Novo ponto beacon
        </Button>
      </div>
      <DataGrid
        sx={dataGridStyles}
        autoHeight
        rows={onlyBeacons}
        columns={columns}
        rowsPerPageOptions={[5]}
        pageSize={5}
        disableSelectionOnClick
      />
      <PointFormModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        type="beacon"
        categories={categories || []}
        pointToEdit={pointToEdit}
        onCreated={(newPoint) => setPoints([...points, newPoint])}
        onSaved={handleSaved}
      />
    </div>
  );
}

BeaconsCard.propTypes = {
  scrollToMapComponent: PropTypes.func.isRequired,
  points: PropTypes.arrayOf(
    PropTypes.object.isRequired,
  ).isRequired,
  setPoints: PropTypes.func.isRequired,
  setAudioFile: PropTypes.func,
  setImageFile: PropTypes.func,
  setFormData: PropTypes.func,
  setFormEditData: PropTypes.func,
  setSelectedCoords: PropTypes.func,
  selectedCoords: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  setSelectedPoint: PropTypes.func,
  categories: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  })),
};
